import React from 'react'
import { Button, Tooltip } from 'antd'

interface PropsType {
  link: string
  icon: React.ReactNode
  disabled: boolean
  disabledTitle: string,
  title: string
}

const IntegrationPurchaseCertificateLink: React.FC<PropsType> = (props) => {
  const { link, icon, disabled, title, disabledTitle } = props

  const handleClick = () => {
    if (!disabled) {
      window.open(link, '_blank')
    }
  }

  return (
    <Tooltip
      mouseEnterDelay={0.1}
      color={disabled ? 'gray' : 'blue'}
      title={disabled ? disabledTitle : title}
    >
      <Button
        type='dashed'
        size='middle'
        shape='circle'
        icon={icon}
        disabled={disabled}
        onClick={handleClick}
      />
    </Tooltip>
  )
}

export default IntegrationPurchaseCertificateLink
